import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Per-route SEO meta. Pass overrides for non-Landing pages.
 * Default values are tuned for the homepage; keeping them inside a single
 * source-of-truth component avoids drift between routes.
 */
const SITE_URL = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");

const DEFAULTS = {
  title: "Dubai Pillows · Luxury 7-Star Hotel Goose Down Pillow | Sleep Like a Sheikh",
  description:
    "The luxury goose down pillow used behind the headboards of Burj Al Arab & Ritz Paris royal suites. Hand-stitched in Dubai, 100-night risk-free trial, free worldwide shipping. From $147.",
  url: `${SITE_URL}/`,
  image: `${SITE_URL}/assets/og-cover.jpg`,
  keywords:
    "luxury pillow, goose down pillow, 7-star hotel pillow, Dubai pillows, Burj Al Arab pillow, best pillow in the world, hand-stitched pillow, sleep like a sheikh, hotel grade pillow",
  noindex: false,
};

export default function Seo({
  title,
  description,
  url,
  image,
  keywords,
  noindex,
  type = "website",
}) {
  const m = {
    title: title || DEFAULTS.title,
    description: description || DEFAULTS.description,
    url: url || DEFAULTS.url,
    image: image || DEFAULTS.image,
    keywords: keywords || DEFAULTS.keywords,
    noindex: noindex !== undefined ? noindex : DEFAULTS.noindex,
  };
  return (
    <Helmet>
      <title>{m.title}</title>
      <meta name="description" content={m.description} />
      <meta name="keywords" content={m.keywords} />
      <link rel="canonical" href={m.url} />
      <meta name="robots" content={m.noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={m.title} />
      <meta property="og:description" content={m.description} />
      <meta property="og:url" content={m.url} />
      <meta property="og:image" content={m.image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={m.title} />
      <meta name="twitter:description" content={m.description} />
      <meta name="twitter:image" content={m.image} />
    </Helmet>
  );
}
